/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { ITeamResponse } from './ITeamResponse';
import {
    ITeamResponseFromJSON,
    ITeamResponseFromJSONTyped,
    ITeamResponseToJSON,
    ITeamResponseToJSONTyped,
} from './ITeamResponse';

/**
 * 
 * @export
 * @interface GetTeamsResponse
 */
export interface GetTeamsResponse {
    /**
     * 
     * @type {Array<ITeamResponse>}
     * @memberof GetTeamsResponse
     */
    teams: Array<ITeamResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetTeamsResponse
     */
    paginationInfo: PaginationInfo;
}

/**
 * Check if a given object implements the GetTeamsResponse interface.
 */
export function instanceOfGetTeamsResponse(value: object): value is GetTeamsResponse {
    if (!('teams' in value) || value['teams'] === undefined) return false;
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    return true;
}

export function GetTeamsResponseFromJSON(json: any): GetTeamsResponse {
    return GetTeamsResponseFromJSONTyped(json, false);
}

export function GetTeamsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTeamsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'teams': ((json['teams'] as Array<any>).map(ITeamResponseFromJSON)),
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function GetTeamsResponseToJSON(json: any): GetTeamsResponse {
    return GetTeamsResponseToJSONTyped(json, false);
}

export function GetTeamsResponseToJSONTyped(value?: GetTeamsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teams': ((value['teams'] as Array<any>).map(ITeamResponseToJSON)),
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
    };
}

